import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/marketing",
    name: "marketing",
    component: dashboard,
    redirect: {
      name: "marketingIndex"
    },
    children: [
      {
        path: "marketingIndex",
        name: "marketingIndex",
        meta: {
          title: "二维码生码查验修复"
        },
        component: () => import("@/views/generatedCode/generatedCode.vue"),
        children: []
      }
    ]
  }
];
